export default __webpack_public_path__ + "static/media/icon-profile-inactive.3e172921.svg";